import { Actions } from "../constants/actionTypes";
import { takeLatest, call, put } from "redux-saga/effects";
import {
  apiBuildSite,
  createStagingDomain,
  fetchOrgById,
} from "../Services/createSite/createSiteAPI.js";

export function* getCreateSiteSelectedOrg() {
  yield takeLatest(Actions.API_CREATE_SITE_SELECTED_ORG, getOrgDetails);
}

function* getOrgDetails(action) {
  const result = yield call(fetchOrgById, action.orgId);

  if (result.isApiSuccessful) {
    yield put({
      type: Actions.SET_CREATE_SITE_SELECTED_ORG,
      data: result.data.licenses,
    });
  } else {
    yield put({ type: Actions.SET_CREATE_SITE_SELECTED_ORG, data: null });
    // Toast("Technical Issue", "Please try again later", "danger");
  }
}

export function* createNewSite() {
  yield takeLatest([Actions.API_CREATE_SITE], buildSite);
}

function* buildSite(action) {
  const result = yield call(apiBuildSite, action);
  if (result.isApiSuccessful) {
    // the BuildResponse carries the SSH login (host/port/username) of a v2 site created with SSH
    action.meta.onSuccess(result.data);
  } else {
    action.meta.onError(result.response?.data?.errorMessage);
  }
  return result;
}

export function* createNewEnvironment() {
  yield takeLatest([Actions.API_CREATE_NEW_STAGING_DOMAIN], buildStagingDomain);
}

function* buildStagingDomain(action) {
  const result = yield call(createStagingDomain, action.data);
  if (result.isApiSuccessful) {
    action.meta.onSuccess();
  } else {
    action.meta.onError(result.response?.data?.errorMessage);
  }
  return result;
}
